import { isNonEmptyArray } from '@/utils/checks'
import { NearbyCity } from '@/types/models/Location.model'

const MAXIMUM_LINKS_PER_COLUMN = 3
export const generateNearbyCitiesPropsFromLocations = ({
  allLocations
}: {
  allLocations: NearbyCity[]
}): NearbyCity[][] => {
  if (!isNonEmptyArray(allLocations)) {
    return []
  }
  return allLocations.reduce(
    (acc: NearbyCity[][], location: NearbyCity, index: number) => {
      if (index % MAXIMUM_LINKS_PER_COLUMN === 0) {
        acc.push([location])
      } else {
        acc[acc.length - 1].push(location)
      }
      return acc
    },
    [] as NearbyCity[][]
  )
}
